import { Reducer } from "redux";

import { BulkImportResponse } from "@/Contracts/BulkImport";
import { Opportunity } from "@/Contracts/Opportunity";
import { Product } from "@/Contracts/Products";
import { Client, ClientContact } from "@/Contracts/Clients";

import {
	BulkImportActionTypes,
	BulkImportActions
} from "../../Actions/BulkImport";
import { AssessmentDataLog } from "@/Contracts/Assessments";
import { HealthStatusDataLog } from "@/Contracts/QBR";

export interface BulkImportState {
	readonly isLoading: boolean;
	readonly bulkImportData: BulkImportResponse<
		| Opportunity
		| Product
		| Client
		| ClientContact
		| AssessmentDataLog
		| HealthStatusDataLog
	> | null;
	readonly spreadsheetBulkImportDrawerOpen: boolean;
	readonly softwareBulkImportDrawerOpen: boolean;
	readonly emailBulkImportDrawerOpen: boolean;
	readonly bulkImportEntityListDrawerOpen: boolean;
}

const initialState: BulkImportState = {
	isLoading: false,
	bulkImportData: null,
	spreadsheetBulkImportDrawerOpen: false,
	softwareBulkImportDrawerOpen: false,
	emailBulkImportDrawerOpen: false,
	bulkImportEntityListDrawerOpen: false
};

export const BulkImportReducer: Reducer<BulkImportState, BulkImportActions> = (
	state: BulkImportState = initialState,
	action: BulkImportActions
): BulkImportState => {
	switch (action.type) {
		case BulkImportActionTypes.SHOW_BULK_IMPORT_LOADER: {
			return {
				...state,
				isLoading: true
			};
		}
		case BulkImportActionTypes.HIDE_BULK_IMPORT_LOADER: {
			return {
				...state,
				isLoading: false
			};
		}
		case BulkImportActionTypes.OPPORTUNITIES_BULK_IMPORT_SUCCESSFUL: {
			return {
				...state,
				bulkImportData: action.bulkImportData
			};
		}
		case BulkImportActionTypes.PRODUCTS_BULK_IMPORT_SUCCESSFUL: {
			return {
				...state,
				bulkImportData: action.bulkImportData
			};
		}
		case BulkImportActionTypes.CLIENTS_BULK_IMPORT_SUCCESSFUL: {
			return {
				...state,
				bulkImportData: action.bulkImportData
			};
		}
		case BulkImportActionTypes.CLIENT_CONTACTS_BULK_IMPORT_SUCCESSFUL: {
			return {
				...state,
				bulkImportData: action.bulkImportData
			};
		}
		case BulkImportActionTypes.ISSUES_BULK_IMPORT_SUCCESSFUL: {
			return {
				...state,
				bulkImportData: action.bulkImportData
			};
		}
		case BulkImportActionTypes.BULK_IMPORT_RESET: {
			return {
				...state,
				bulkImportData: null
			};
		}
		case BulkImportActionTypes.SPREADSHEET_BULK_IMPORT_DRAWER_OPENED: {
			return {
				...state,
				spreadsheetBulkImportDrawerOpen: true
			};
		}
		case BulkImportActionTypes.SPREADSHEET_BULK_IMPORT_DRAWER_CLOSED: {
			return {
				...state,
				spreadsheetBulkImportDrawerOpen: false
			};
		}
		case BulkImportActionTypes.SOFTWARE_BULK_IMPORT_DRAWER_OPENED: {
			return {
				...state,
				softwareBulkImportDrawerOpen: true
			};
		}
		case BulkImportActionTypes.SOFTWARE_BULK_IMPORT_DRAWER_CLOSED: {
			return {
				...state,
				softwareBulkImportDrawerOpen: false
			};
		}
		case BulkImportActionTypes.EMAIL_BULK_IMPORT_DRAWER_OPENED: {
			return {
				...state,
				emailBulkImportDrawerOpen: true
			};
		}
		case BulkImportActionTypes.EMAIL_BULK_IMPORT_DRAWER_CLOSED: {
			return {
				...state,
				emailBulkImportDrawerOpen: false
			};
		}
		case BulkImportActionTypes.BULK_IMPORT_ENTITY_LIST_DRAWER_OPENED: {
			return {
				...state,
				bulkImportEntityListDrawerOpen: true
			};
		}
		case BulkImportActionTypes.BULK_IMPORT_ENTITY_LIST_DRAWER_CLOSED: {
			return {
				...state,
				bulkImportEntityListDrawerOpen: false
			};
		}
		case BulkImportActionTypes.RESTORE_BULK_IMPORT_STATE: {
			return {
				...state,
				spreadsheetBulkImportDrawerOpen: action.bulkImportState.spreadsheetBulkImportDrawerOpen || false
			};
		}
		default: {
			return state;
		}
	}
};

export default BulkImportReducer;
